import network from '@common/network/network';

export default {
  fetchStoryAction(context, {slug, tree_id}) {
    context.commit('setStoryLoadingState', true);
    return new Promise((resolve, reject) => {
      network.fws
        .getStory({slug, tree_id})
        .then(response => {
          context.commit('setStoryState', response);
          resolve(response);
        })
        .catch(reject)
        .finally(() => {
          context.commit('setStoryLoadingState', false);
        });
    });
  },
  fetchStoriesCompilationAction(context, {tree_id, slug}) {
    context.commit('setStoriesCompilationLoadingState', true);
    return new Promise((resolve, reject) => {
      network.fws
        .getStoriesCollection({tree_id, slug})
        .then(response => {
          context.commit('setStoriesCompilationState', response);
          resolve(response);
        })
        .catch(reject)
        .finally(() => {
          context.commit('setStoriesCompilationLoadingState', false);
        });
    });
  },
  fetchStoriesCompilationsListAction(context, {tree_id}) {
    context.commit('setStoriesCompilationsListLoadingState', true);
    return new Promise((resolve, reject) => {
      network.fws
        .getStoriesCollections({tree_id})
        .then(response => {
          context.commit('setStoriesCompilationsListState', response.objects);
          resolve(response);
        })
        .catch(reject)
        .finally(() => {
          context.commit('setStoriesCompilationsListLoadingState', false);
        });
    });
  },
  updateStoriesCompilationAction(context, {tree_id, slug, ...params}) {
    context.commit('setUpdateStoriesCompilationLoadingState', true);
    const {cover_image, ...other} = params;
    const is_public = params.is_public;
    const data = JSON.stringify(other);

    return new Promise((resolve, reject) => {
      network.fws
        .updateStoriesCollection({tree_id, slug, cover_image, data})
        .then(response => {
          if (context.getters.storiesCompilationState.slug === slug && typeof is_public == 'boolean') {
            context.commit('mutateStoriesCompilationState', {is_public});
          }
          resolve();
        })
        .catch(reject)
        .finally(() => {
          context.commit('setUpdateStoriesCompilationLoadingState', false);
        });
    });
  },
  fetchStoriesListAction(
    context,
    {
      page,
      limit,
      append,
      tree_id,
      q,
      exclude_collection,
      collections,
      sources,
      places,
      tags,
      clans,
      tree_persons,
      mention_persons,
      authors,
      ownership,
    }
  ) {
    page = page || 1;
    limit = limit || 10;
    const offset = limit * (page - 1);
    context.commit('setStoriesLoadingState', true);
    return new Promise((resolve, reject) => {
      network.fws
        .getStories({
          limit,
          offset,
          tree_id,
          q,
          exclude_collection,
          collections,
          sources,
          places,
          tags,
          clans,
          tree_persons,
          mention_persons,
          authors,
          ownership,
        })
        .then(response => {
          if (append) {
            context.commit('appendStoriesListState', response.objects);
          } else {
            context.commit('setStoriesListState', response.objects);
          }
          context.commit('setStoriesMetaState', response.meta);
          resolve(response);
        })
        .catch(reject)
        .finally(() => {
          context.commit('setStoriesLoadingState', false);
        });
    });
  },
  fetchStoriesAutocompleteAction(context, {search, tree_id}) {
    return new Promise((resolve, reject) => {
      network.fws.getStoriesAutocomplete({search, tree_id}).then(resolve).catch(reject);
    });
  },
  createStoryAction(context, {tree_id, ...params}) {
    context.commit('setStoryCreateLoadingState', true);
    return new Promise((resolve, reject) => {
      network.fws
        .createStory({tree_id, ...params})
        .then(resolve)
        .catch(reject)
        .finally(() => {
          context.commit('setStoryCreateLoadingState', false);
        });
    });
  },
  updateStoryAction(context, {tree_id, slug, ...params}) {
    context.commit('setUpdateStoryLoadingState', true);
    return new Promise((resolve, reject) => {
      network.fws
        .updateStory({tree_id, slug, ...params})
        .then(response => {
          if (context.getters.storyState.slug === slug) {
            context.commit('mutateStoryState', params);
          }
          resolve(response);
        })
        .catch(reject)
        .finally(() => {
          context.commit('setUpdateStoryLoadingState', false);
        });
    });
  },
  createStoryPinAction(context, {tree_id, story_id, collection_id, order}) {
    context.commit('setStoryPinLoadingState', true);
    return new Promise((resolve, reject) => {
      network.fws
        .createStoryPin({tree_id, story_id, collection_id, order})
        .then(resolve)
        .catch(reject)
        .finally(() => {
          context.commit('setStoryPinLoadingState', false);
        });
    });
  },
  deleteStoryPinAction(context, {tree_id, story_id, collection_id, order}) {
    context.commit('setStoryPinLoadingState', true);
    return new Promise((resolve, reject) => {
      network.fws
        .deleteStoryPin({tree_id, story_id, collection_id, order})
        .then(resolve)
        .catch(reject)
        .finally(() => {
          context.commit('setStoryPinLoadingState', false);
        });
    });
  },
  createStoriesCollectionAction(context, {tree_id, ...params}) {
    const {cover_image, ...other} = params;
    const data = JSON.stringify(other);
    return new Promise((resolve, reject) => {
      network.fws.createStoriesCollection({tree_id, cover_image, data}).then(resolve).catch(reject);
    });
  },
  bulkCreateStoriesCompilationAction(context, {tree_id, story_ids, title, description, is_public}) {
    return new Promise((resolve, reject) => {
      network.fws
        .bulkCreateStoriesCompilation({tree_id, story_ids, title, description, is_public})
        .then(resolve)
        .catch(reject);
    });
  },
  bulkTagStoriesAction(context, {tree_id, story_ids, tags}) {
    return new Promise((resolve, reject) => {
      network.fws.bulkTagStories({tree_id, story_ids, tags}).then(resolve).catch(reject);
    });
  },
  bulkPublishStoriesAction(context, {tree_id, story_ids}) {
    return new Promise((resolve, reject) => {
      network.fws.bulkPublishStories({tree_id, story_ids}).then(resolve).catch(reject);
    });
  },
  bulkAddStoriesToCompilationAction(context, {tree_id, story_ids, collection_id}) {
    return new Promise((resolve, reject) => {
      network.fws.bulkAddStoriesToCompilation({tree_id, story_ids, collection_id}).then(resolve).catch(reject);
    });
  },
  searchStoriesAction(context, params) {
    return new Promise((resolve, reject) => {
      network.fws.searchStories(params).then(resolve).catch(reject);
    });
  },
};
